import { extract } from 'fuzzball';

// 80 is an arbitrary value set to determine how close of a match we're expecting. FuzzBall provides rankings on a 0-100 scale.
export const FUZZY_MATCH_THRESHOLD = 80;
export const FUZZY_MATCH_PERFECT = 100;

/**
 * Matches strings based on similarity
 */
export const findFuzzyMatch = (needle: string, haystack: string[]): any => {
    const ratings = extract(needle, haystack);
    const bestMatch = ratings[0];
    const target = bestMatch[0];
    const rating = bestMatch[1];
    const bestMatchIndex = bestMatch[2];

    return { target, rating, bestMatchIndex, ratings };
};
